<template>
  <Content :button-create-show="!!selected_c" :create-id="selected_c">
    <template #body>
      <p>Город:</p>
      <el-select
        v-model="selected_c"
        :multiple="false"
        placeholder="Выберте город"
        filterable
        clearable
        style="width: 100%; margin-bottom: 30px"
      >
        <el-option
          v-for="item in cities"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
      </el-select>
      <Table
        v-if="selected_c"
        :columns="columns"
        :options="columnsOptions"
        :method-fetch-data-id="methods.fetchData"
        :method-delete-row="methods.deleteRow"
        :by-id="id"
        :edit-by-id="true"
        ref="table"
      />
    </template>
  </Content>
</template>

<script>
import Content from "@/layout/Content";
import Table from "@/components/Table";
import { getCities } from "@/api/cities";

import {
  getMuseums as fetchData,
  deleteMuseum as deleteRow,
} from "@/api/museums";

const columnsOptions = {
  sortable: "custom",
  controls: true,
  edit: true,
  id: "id",
  delete_row: {
    buttonName: "Удалить",
  },
};

const columns = [
  {
    prop: "id",
    label: "ID",
    width: 50,
  },
  {
    prop: "name",
    label: "Название",
  },
  {
    prop: "description",
    label: "Описание музея / площадки",
    sortable: false,
  },
  {
    prop: "logoUrl",
    label: "Лого",
    sortable: false,
    type: "preview",
  },
  {
    prop: "recommendationImage",
    label: "Превью рекомендации",
    sortable: false,
    type: "preview",
  },
  {
    prop: "schedule",
    label: "расписание",
    sortable: false,
  },
  {
    prop: "address",
    label: "Адрес",
    sortable: false,
  },
  {
    prop: "mapLink",
    label: "Ссылка на карту",
    sortable: false,
    type: "ext_link",
  },
  {
    prop: "recommendations",
    label: "Рекомендации",
    type: "list-data",
    sortable: false,
  },
  {
    prop: "timePadLink",
    label: "Ссылка на timepad",
    sortable: false,
    type: "ext_link_full",
  },
  {
    prop: "textDate",
    label: "Текст даты",
    sortable: false,
  },
  {
    prop: "textTicket",
    label: "Текст билета",
    sortable: false,
  },
];

export default {
  components: {
    Content,
    Table,
  },
  data() {
    return {
      selected_c: null,
      cities: null,
      id: null,
      columnsOptions: columnsOptions,
      columns: columns,
      methods: {
        fetchData,
        deleteRow,
      },
    };
  },
  async created() {
    const data = await getCities();
    this.cities = data;
    this.selected_c = this.cities[0].id;
  },
  watch: {
    selected_c(val) {
      this.id = val;
    },
  },
};
</script>
